import { useState, useEffect } from "react";
import axios from "axios";
import { getTokenCookie } from "../Login/cookie";
import HeaderLogoIcon from "../../components/headerLogoIcons/headerLogoIcons";
import { FooterIndex } from "../../components";
import "./profileUser.css";

const ProfileUser = () => {
  const [dataProfile, setDataProfile] = useState({});
  const [load, setLoad] = useState(true);

  useEffect(() => {
    async function fetchData() {
      // Obtiene el token desde las cookies
      const token = getTokenCookie();

      // Hace la petición incluyendo el token como un parámetro de consulta
      const response = await axios.get(
        `${process.env.REACT_APP_PROFILE_ADMIN}${token}`
      );

      setLoad(false);
      setDataProfile(response.data);
    }
    fetchData();
  }, []);

  return (
    <div className="heighvh">
      <HeaderLogoIcon />
      {!load ? (
        <div className="box-profile-amebo">
          <div>
            <p className="tittle-pro-amebo">Perfil</p>
          </div>
          <div className="box-profile-display-amebo">
            <div className="box-info-profile-amebo">
              <p className="info-text-tittle-amebo">Nombre:</p>
              <div>
                <p className="info-text-profile-amebo">{dataProfile.name}</p>
              </div>
            </div>
            <div className="box-info-profile-amebo">
              <p className="info-text-tittle-amebo">Apellido:</p>
              <p className="info-text-profile-amebo">{dataProfile.lastName}</p>
            </div>
          </div>
          <div className="box-profile-display-amebo">
            <div className="box-info-profile-amebo">
              <p className="info-text-tittle-amebo">Celular:</p>
              <p className="info-text-profile-amebo"> {dataProfile.phone}</p>
            </div>
            <div className="box-info-profile-amebo">
              <p className="info-text-tittle-amebo">Cuil:</p>
              <p className="info-text-profile-amebo">{dataProfile.cuil}</p>
            </div>
          </div>
          <div className="box-profile-display-amebo">
            <div className="box-info-profile-amebo">
              <p className="info-text-tittle-amebo">Email:</p>
              <p className="info-text-profile-amebo">{dataProfile.email}</p>
            </div>
          </div>
        </div>
      ) : (
        <div className="loader"></div>
      )}

      <FooterIndex />
    </div>
  );
};

export default ProfileUser;
